<app-nav-bar></app-nav-bar>
<div>
  <div class="container-fluid" id="main">
    <div class="row mb-2" id="content">
      <div class="col-12">
        <app-limit-hours *ngIf="isRoot"></app-limit-hours>
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
